import { paginationResponseTransformer } from '@/utils/pagination/pagination';
import { getRequest, postRequest, putRequest } from '../request/request.service';
import { Documents, DocumentsFilters, Document, UpdateDocumentPayload, CreateDocumentPayload } from './documents-service.types';

const DOCUMENTS_URL = 'documents';
export function getDocuments(params: DocumentsFilters) {
  return getRequest<Documents>(`/${DOCUMENTS_URL}`, { params }, paginationResponseTransformer);
}

export function getDocument(id: string) {
  return getRequest<Document>(`/${DOCUMENTS_URL}/${id}`);
}

export function editDocument(id: string, data: UpdateDocumentPayload) {
  return putRequest<Document>(`/${DOCUMENTS_URL}/${id}`, { data });
}

export function addDocument(payload: CreateDocumentPayload) {
  return postRequest<Document>(`/${DOCUMENTS_URL}`, { data: { document: payload } });
}
